<template>
  <v-dialog
      :value="internalValue"
  >
    <v-card>
      <v-card-title class="primary headline">
        <v-row>
          <v-col>Neu hier?!</v-col>
          <v-spacer />
          <v-col class="flex-shrink-1 flex-grow-0">
            <v-btn
                text
                @click="close"
            >Ich weiß was ich will!</v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step
              :complete="step > 1"
              :step="1"
          >Step A</v-stepper-step>

          <v-divider />

          <v-stepper-step
              :complete="step > 2"
              :step="2"
          >Step B</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :step="3"
          >Step C</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content :step="1">
            <v-card
                flat
                color="grey lighten-2"
            >
              <v-card-text>
                Erster Schritt...
              </v-card-text>
            </v-card>
            <v-row>
              <v-spacer />
              <v-col
                  class="flex-shrink-1 flex-grow-0"
              >
                <v-btn
                    color="secondary"
                    @click="advance"
                >Next</v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content :step="2">
            <v-card
                flat
                color="grey lighten-2"
            >
              <v-card-text>
                Zweiter Schritt...
              </v-card-text>
            </v-card>
            <v-row>
              <v-col
                  class="flex-shrink-1 flex-grow-0"
              >
                <v-btn
                    @click="goBack"
                >Prev</v-btn>
              </v-col>
              <v-spacer />
              <v-col
                  class="flex-shrink-1 flex-grow-0"
              >
                <v-btn
                    color="secondary"
                    @click="advance"
                >Next</v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content :step="3">
            <v-card
                flat
                color="grey lighten-2"
            >
              <v-card-text>
                Dritter Schritt...
              </v-card-text>
            </v-card>
            <v-row>
              <v-col
                  class="flex-shrink-1 flex-grow-0"
              >
                <v-btn
                    @click="goBack"
                >Prev</v-btn>
              </v-col>
              <v-spacer />
              <v-col
                  class="flex-shrink-1 flex-grow-0"
              >
                <v-btn
                    color="primary"
                    @click="close"
                >End</v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GhDialogWelcome',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    step: 1,
    internalValue: false
  }),
  watch: {
    value: 'setValue'
  },
  created () {
    this.setValue(this.value)
  },
  methods: {
    close () {
      this.internalValue = false
      this.emitInput()
    },
    /* eslint-disable-next-line no-unused-vars */
    setValue (newVal, oldVal) {
      this.internalValue = !!newVal
    },
    onInput (value) {
      this.internalValue = value
      this.emitInput()
    },
    emitInput () {
      this.$emit('input', this.internalValue)
    },
    advance () {
      if (this.step < 3) {
        this.step++
      }
    },
    goBack () {
      if (this.step > 1) {
        this.step--
      }
    }
  }
}
</script>

<style scoped>

</style>
